import React from "react";
import { Trash2 } from "lucide-react";
import { MeetingParticipant } from "../../../types/meeting";

interface UserParticipantCardProps {
  participant: MeetingParticipant;
  canDelete: boolean;
  onDelete: (participant: MeetingParticipant) => void;
  isDeleting: boolean;
}

export default function UserParticipantCard({ participant, canDelete, onDelete, isDeleting }: UserParticipantCardProps) {
  return (
    <div className="w-full px-4 py-3 text-left text-sm hover:bg-gray-50 flex items-center gap-3 bg-white transition-colors">
      <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 overflow-hidden">
        {participant.user?.media?.url ? (
          <img
            src={participant.user.media.url}
            alt={`${participant.user?.firstName} ${participant.user?.lastName}`}
            className="w-full h-full object-cover"
          />
        ) : (
          <span className="text-xs font-semibold text-blue-600">{(participant.user?.firstName || "").charAt(0) || "U"}</span>
        )}
      </div>
      <div className="min-w-0 flex-1">
        <div className="font-medium text-gray-900 truncate">
          {`${participant.user?.firstName || ""} ${participant.user?.lastName || ""}`.trim() || "İsimsiz Kullanıcı"}
        </div>
        {participant.user?.email && <div className="text-xs text-gray-500 truncate">{participant.user.email}</div>}
      </div>

      {canDelete && (
        <button
          onClick={() => onDelete(participant)}
          disabled={isDeleting}
          className="p-1.5 text-red-500 hover:text-red-700 hover:bg-red-50 rounded disabled:opacity-50 transition-colors flex-shrink-0"
          title="Kullanıcıyı Çıkar">
          {isDeleting ? (
            <div className="animate-spin h-3 w-3 border-2 rounded-full border-t-transparent border-red-500"></div>
          ) : (
            <Trash2 className="w-3 h-3" />
          )}
        </button>
      )}
    </div>
  );
}
